import React, { useState, useEffect, useCallback } from "react";
import axios from "../../plugins/axios";
import moment from "moment";
import { useAuth } from "../../contexts/authContext";
import {
    Box,
    Tab,
    Tabs,
    CircularProgress,
    Tooltip,
} from "@mui/material";
import TabPanel from "../TabPanel";
import { makeStyles } from '@mui/styles';
import Visits from './Visits';
import DailyTimeSheet from './DailyTimeSheet';
import AdviceEntries from './AdviceEntries';

const apiUrl = process.env.REACT_APP_WORKNEST_TOOLS_API_URL;


const useStyles = makeStyles(theme => ({
    spinnerContainer: {
        display: 'flex',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center'
    },
}))

const TimeSheet = () => {

    const classes = useStyles();

    const { user } = useAuth();
    
    const [visits, setVisits] = useState([]);
    const [employeeId, setEmployeeId] = useState(null);
    const [loading, setLoading] = useState(true);   

    const [currentTab, setCurrentTab] = useState("daily");    

    const [activityTypes, setActivityTypes] = useState([]);
    const [advisoryTypes, setAdvisoryTypes] = useState([]);

    const calcDuration = useCallback((start, end) => {
        var duration = "";

        if (start && end) {
            let totalMinutes = moment(end).diff(start, "minutes");
            console.log(totalMinutes);
            let hours = Math.floor(totalMinutes / 60);
            let minutes = totalMinutes - hours * 60;
            duration =
                totalMinutes <= 0
                    ? "Invalid"
                    : `${hours}:${minutes.toString().padStart(2, "0")}`;
        }

        return duration;
    }, []);

    const filesTooltip = useCallback((filenames) => {

        if (filenames.length === 0)
            return 0;

        let title = (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                {filenames.map((f, index) =>
                    <div key={index}>{f}</div>
                )}
            </div>
        );

        return <Tooltip style={{ cursor: 'pointer' }} title={title}><span>{filenames.length}</span></Tooltip>
    }, []);

    useEffect(() => {

        const getInitialData = async () => {
            if (user) {
                setLoading(true);
                var response = await axios.get(`${apiUrl}/timesheetinitial`);                
                setEmployeeId(response.data.employeeId);
                setVisits(response.data.visits || []);
                setActivityTypes(response.data.activityTypes);
                setAdvisoryTypes(response.data.advisoryTypes);
                setLoading(false);
            }
        }
        getInitialData();
    }, [user]);   

    if (!user)
        return null;

    if (loading)
        return <div className={classes.spinnerContainer}>
            <CircularProgress />
        </div>

    if (!user && !loading && !employeeId)
        return <h1>Employee not registered in Salesforce!</h1>;

    return (
        <Box display="flex" flexDirection="column" style={{ paddingTop: "10px" }} gap="10px">
            <Tabs value={currentTab} onChange={(e, x) => setCurrentTab(x)} style={{ marginBottom: '10px' }}>
                <Tab value="daily" label="Daily Timesheet" />
                <Tab value="advice" label="Advice" />
                {visits.length > 0 && <Tab value="visits" label="Visits" />}
            </Tabs>
            <TabPanel value={currentTab} index="daily" >
                <DailyTimeSheet user={user} calcDuration={calcDuration} activityTypes={activityTypes} advisoryTypes={advisoryTypes} filesTooltip={filesTooltip} />
            </TabPanel>
            <TabPanel value={currentTab} index="advice" >
                <AdviceEntries calcDuration={calcDuration} employeeId={employeeId} activityTypes={activityTypes} advisoryTypes={advisoryTypes} filesTooltip={filesTooltip} />
            </TabPanel>
            <TabPanel value={currentTab} index="visits" >
                <Visits visits={visits} setVisits={setVisits} setCurrentTab={setCurrentTab} />
            </TabPanel>
            
        </Box>
    );
};

export default TimeSheet;
